import { Fragment, ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import Dot from 'components/common/dot/Dot';
import { styled } from '@mui/material/styles';

type DotSeparatedListProps = {
  items: ReactNode[];
  sx?: SxProps<Theme>;
};

const DotSeparatedList = ({ items, sx }: DotSeparatedListProps) => {
  if (!items || items.length === 0) return null;

  const filteredItems = items.filter(
    (item) =>
      item !== null &&
      item !== undefined &&
      !(typeof item === 'boolean' && !item) &&
      !(typeof item === 'string' && item.trim() === '') &&
      !(typeof item === 'number' && item === 0),
  );

  if (filteredItems.length === 0) return null;

  return (
    <Container sx={sx}>
      {filteredItems.map((item, index) => (
        <Fragment key={index}>
          {item}
          {index < filteredItems.length - 1 && <Dot />}
        </Fragment>
      ))}
    </Container>
  );
};

const Container = styled(Box)(({ theme }) => ({
  fontWeight: 400,
  fontSize: 13,
  lineHeight: '18px',
  letterSpacing: '0.25px',
  color: theme.palette.custom.label,
  display: 'flex',
  alignItems: 'center',
}));

export default DotSeparatedList;
